'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Counter = require('./Counter2');

var _Counter2 = _interopRequireDefault(_Counter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_React$Component) {
    _inherits(Checkbox, _React$Component);

    function Checkbox(props) {
        _classCallCheck(this, Checkbox);

        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

        _this.getDataRowFromCheckBoxData = function () {
            var optionKeys = [];

            if (_this.props.checkBoxData.options) {

                optionKeys = _this.props.checkBoxData.options.map(function (option) {
                    return _lodash2.default.keys(option)[0];
                });
            } else {
                var filteredData = _lodash2.default.omit(_this.props.checkBoxData, ['category', 'minChoose', 'maxChoose', 'required', 'allowOptionQty']);

                optionKeys = _lodash2.default.keys(filteredData);
            }

            return optionKeys;
        };

        _this.getOptionObject = function (option) {
            var checkBoxData = _this.props.checkBoxData;
            var optionObject = null;

            if (checkBoxData.options) {
                optionObject = checkBoxData.options.find(function (x) {
                    return _lodash2.default.keys(x)[0] === option;
                });
            }

            return optionObject;
        };

        _this.getExtraCost = function (option, optionObject) {
            var extraCost = '';

            if (optionObject) {
                extraCost = optionObject[option].price === 0 ? '' : '+ $' + optionObject[option].price;
            } else {
                extraCost = _this.props.checkBoxData[option] === 0 ? '' : '+ $' + _this.props.checkBoxData[option];
            }

            return extraCost;
        };

        _this.isOptionOos = function (option, optionObject) {
            var isOptionOos = false;

            if (optionObject) {
                isOptionOos = optionObject[option].oos;
            }

            return isOptionOos;
        };

        _this.state = {
            globalCheckbox: false,
            minChoose: 0,
            maxChoose: 0,
            maxChooseCopy: 0,
            required: false,
            data: {},
            isSelectionValid: true,
            isRestrictedSelection: false,
            optionQtyContainer: {}
        };

        _this.updateMaxQty = _this.updateMaxQty.bind(_this);
        _this.linkCheckbox = _this.linkCheckbox.bind(_this);
        _this.changeCheckForId = _this.updateMaxQty.bind(_this);
        _this.toggleCheckbox = _this.toggleCheckbox.bind(_this);
        _this.getCheckboxLabel = _this.getCheckboxLabel.bind(_this);
        _this.changeCheckForAll = _this.changeCheckForAll.bind(_this);
        _this.validateRequiredSelection = _this.validateRequiredSelection.bind(_this);
        return _this;
    }

    _createClass(Checkbox, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var category = this.props.checkBoxData.category;
            var minChoose = this.props.checkBoxData.minChoose;
            var maxChoose = this.props.checkBoxData.maxChoose;
            var required = this.props.checkBoxData.required;
            var maxChooseCopy = this.props.checkBoxData.maxChoose;
            var isRestrictedSelection = !(minChoose === 0 && maxChoose === 0);

            var checkBoxItems = {};

            var optionKeys = this.getDataRowFromCheckBoxData();
            optionKeys.forEach(function (d) {
                checkBoxItems[d] = 0;
            });

            if (this.props.priorCheckBoxData != null) {
                this.props.priorCheckBoxData.forEach(function (key) {
                    checkBoxItems[key] = checkBoxItems[key] + 1;
                    maxChooseCopy = maxChooseCopy - 1;
                });
            }

            this.setState({
                data: checkBoxItems,
                minChoose: minChoose,
                maxChoose: maxChoose,
                maxChooseCopy: maxChooseCopy,
                isRestrictedSelection: isRestrictedSelection,
                required: required
            });
        }
    }, {
        key: 'changeCheckForId',
        value: function changeCheckForId(id, bool) {
            var _this2 = this;

            var changedData = this.state.data.map(function (d) {
                var newSelected = d.id === id ? bool : d.selected;
                return { id: d.id, selected: newSelected };
            });

            var selectedOption = changedData.filter(function (d) {
                return d.selected;
            }).map(function (d) {
                return d.id;
            });

            var len = selectedOption.length;
            var isSelectionValid = false;

            if (!this.state.required || this.state.required && len >= this.state.minChoose && len <= this.state.maxChoose) {
                isSelectionValid = true;
            }
            this.setState({
                data: changedData,
                isSelectionValid: isSelectionValid
            }, function () {
                _this2.props.callbackParent(selectedOption);
            });
        }
    }, {
        key: 'updateMaxQty',
        value: function updateMaxQty(newValue, optionName) {
            var _this3 = this;

            this.setState(function (state, props) {
                var newState = _extends({}, state.data, _defineProperty({}, optionName, newValue));
                var totalSelection = Object.keys(newState).reduce(function (res, curr) {
                    return res + newState[curr];
                }, 0);

                var maxChooseCopy = state.maxChoose - totalSelection;

                var resultState = {};
                if (maxChooseCopy >= 0 || !state.isRestrictedSelection) {
                    resultState = {
                        data: newState,
                        maxChooseCopy: maxChooseCopy
                    };
                } else {
                    resultState = {
                        data: state.data,
                        maxChooseCopy: state.maxChooseCopy
                    };
                }

                return resultState;
            }, function () {
                _this3.props.callbackParent(_this3.expandSelectedOptions(_this3.state.data));
            });
        }
    }, {
        key: 'validateRequiredSelection',
        value: function validateRequiredSelection() {
            var selectedOption = this.state.data.filter(function (d) {
                return d.selected;
            }).map(function (d) {
                return d.id;
            });
            var len = selectedOption.length;
            if (!this.state.required || this.state.required && len >= this.state.minChoose && len <= this.state.maxChoose) {
                return true;
            }
            return false;
        }
    }, {
        key: 'changeCheckForAll',
        value: function changeCheckForAll(bool) {
            this.setState({
                globalCheckbox: true,
                data: this.state.data.map(function (d) {
                    return { id: d.id, selected: bool };
                })
            });
        }
    }, {
        key: 'linkCheckbox',
        value: function linkCheckbox(d) {
            var _this4 = this;

            return {
                value: d.selected,
                requestChange: function requestChange(bool) {
                    _this4.changeCheckForId(d.id, bool);
                }
            };
        }
    }, {
        key: 'toggleCheckbox',
        value: function toggleCheckbox(e) {
            var _this5 = this;

            var data = this.state.data;
            var maxChooseCopy = this.state.maxChooseCopy;
            var optionName = e.target.value;
            var oldOptionValue = data[optionName];

            var newOptionValue = oldOptionValue == 0 ? 1 : 0;

            if (!this.state.isRestrictedSelection) {

                var newData = _extends({}, this.state.data, _defineProperty({}, optionName, newOptionValue));

                this.setState({ data: newData }, function () {
                    _this5.props.callbackParent(_this5.expandSelectedOptions(newData));
                });

                return;
            }

            if (oldOptionValue > 0) {
                maxChooseCopy = maxChooseCopy + oldOptionValue;
            }
            maxChooseCopy = maxChooseCopy - newOptionValue;
            if (maxChooseCopy >= 0) {

                var _newData = _extends({}, this.state.data, _defineProperty({}, optionName, newOptionValue));
                this.setState({ data: _newData, maxChooseCopy: maxChooseCopy }, function () {
                    _this5.props.callbackParent(_this5.expandSelectedOptions(_newData));
                });
            }
        }
    }, {
        key: 'expandSelectedOptions',
        value: function expandSelectedOptions(data) {
            return _lodash2.default.keys(data).reduce(function (acc, key) {
                return acc.concat(Array(data[key]).fill(key));
            }, []);
        }
    }, {
        key: 'getCheckboxLabel',
        value: function getCheckboxLabel() {
            var min = this.state.minChoose;
            var max = this.state.maxChoose;
            var isRequired = this.state.required;

            var customMessage = '';

            if (isRequired) {
                if (min == 1 && max == 1) {
                    return customMessage;
                }
                if (min == 1 && max != min) {
                    // customMessage = `(Choose up to ${max})`;
                    customMessage = '(Choose min ' + min + ', max ' + max + ')';
                } else if (min > 1 && max != min) {
                    customMessage = '(Choose min ' + min + ', max ' + max + ')';
                } else if (min > 1 && max == min) {
                    customMessage = '(Choose ' + max + ')';
                }
            } else {
                if (min == 0 && max == 0) {
                    return customMessage;
                } else {
                    customMessage = '(Choose up to ' + max + ')';
                }
            }

            return customMessage;
        }
    }, {
        key: 'updateRequiredComponent',
        value: function updateRequiredComponent() {

            var component = "";

            var minChoose = this.state.minChoose;
            var maxChoose = this.state.maxChoose;
            var maxChooseCopy = this.state.maxChooseCopy;
            var selectedOption = maxChoose - maxChooseCopy;

            if (selectedOption >= minChoose) {
                component = _react2.default.createElement(
                    'span',
                    { type: 'button', className: 'pull-right span-success m-t-13' },
                    _react2.default.createElement('i', {
                        className: 'fa fa-check span-success-icon' }),
                    'Required'
                );
            } else {
                component = _react2.default.createElement(
                    'span',
                    { type: 'button', className: 'pull-right span-warning m-t-13' },
                    _react2.default.createElement('i', {
                        className: 'fa fa-warning span-warning-icon' }),
                    ' Required'
                );
            }

            return component;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            var checks = _lodash2.default.keys(this.state.data).map(function (d) {

                var optionObject = _this6.getOptionObject(d);
                var extraCost = _this6.getExtraCost(d, optionObject);
                var isOptionOos = _this6.isOptionOos(d, optionObject);

                var isOptionChecked = _this6.state.data[d] > 0 ? true : false;

                var checkBoxClass = "checkmark";
                var labelClass = "container-checkbox pull-left chk-lbl";
                if (_this6.state.minChoose == 0 && _this6.state.maxChoose == 0) {
                    checkBoxClass = "checkmark";
                    labelClass = "container-checkbox pull-left chk-lbl";
                } else if (isOptionChecked != true && _this6.state.maxChooseCopy <= 0) {
                    checkBoxClass = "checkmark checkmark-disabled";
                    labelClass = "container-checkbox pull-left chk-lbl label-disabled";
                } else {
                    // no need to update anything
                }

                return _react2.default.createElement(
                    'div',
                    { className: ' ' + (isOptionOos ? 'disabled' : '') + ' padding-left-right checkbox-div', key: 'chk' + d },
                    _react2.default.createElement(
                        'label',
                        { className: '' + (_this6.props.checkBoxData.allowOptionQty ? labelClass + " " + "labelWidth" : labelClass) },
                        d,
                        ' ',
                        extraCost,
                        ' ',
                        isOptionOos ? " [SOLD]" : '',
                        _react2.default.createElement('input', {
                            type: 'checkbox',
                            value: d,
                            checked: isOptionChecked,
                            onChange: _this6.toggleCheckbox,
                            disabled: isOptionOos
                        }),
                        _react2.default.createElement('span', { className: checkBoxClass })
                    ),
                    _this6.props.checkBoxData.allowOptionQty ? _react2.default.createElement(_Counter2.default, {
                        currentValue: _this6.state.data[d],
                        forOption: d,
                        min: 0,
                        max: _this6.state.maxChooseCopy,
                        callbackParent: _this6.updateMaxQty,
                        isRestrictedSelection: _this6.state.isRestrictedSelection,
                        disabled: isOptionOos
                    }) : null,
                    _react2.default.createElement('span', { className: 'clearfix' })
                );
            });

            // var hasError=!this.validateRequiredSelection()?{color:'rgb(252, 35, 35)'}:{color:'#666'};
            return _react2.default.createElement(
                'div',
                { className: 'form-group' },
                _react2.default.createElement(
                    'label',
                    { className: this.props.cssClass },
                    this.props.label,
                    this.state.required ? this.updateRequiredComponent() : null,
                    this.getCheckboxLabel() ? _react2.default.createElement(
                        'div',
                        { className: "label-option-text" },
                        this.getCheckboxLabel()
                    ) : null
                ),
                checks
            );
        }
    }]);

    return Checkbox;
}(_react2.default.Component);

exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/Checkbox.jsx
// module id = 481
// module chunks = 0